import { gql } from '@apollo/client'

export const RESET_TEAMS = gql`
  mutation ResetTeams($input: ResetTeamsInput!) {
    resetTeams(input: $input) {
      fantasyLeague {
        id
        name
        members {
          id
          budget
          players {
            id
            nick
            name
            lastName
            role
            marketValue
            image
            team {
              id
              nameShow
              shortName
              shield
            }
          }
        }
      }
      errors
    }
  }
`

export const DELETE_LEAGUE = gql`
  mutation DeleteLeague($input: DeleteLeagueInput!) {
    deleteLeague(input: $input) {
      success
      errors
    }
  }
`

export const REMOVE_FANTASY_LEAGUE_MEMBER = gql`
  mutation RemoveFantasyLeagueMember($input: RemoveFantasyLeagueMemberInput!) {
    removeFantasyLeagueMember(input: $input) {
      success
      errors
    }
  }
`

export const UPDATE_LEAGUE_ADMINS = gql`
  mutation UpdateLeagueAdmins($input: UpdateLeagueAdminsInput!) {
    updateLeagueAdmins(input: $input) {
      success
      errors
    }
  }
`

export const ROTATE_SECRET_CODE = gql`
  mutation RotateSecretCode($input: RotateSecretCodeInput!) {
    rotateSecretCode(input: $input) {
      fantasyLeague {
        id
        secretCode
      }
      errors
    }
  }
`
